import { routesAsSet, RouteMetadata } from "./index";
import { RouteID } from "./routes";
import { useExploreParams } from "../visualization/paramSchemas";
import { useEffect } from "react";
import { getNumericIdFromStringLocationId } from "@atlas-int/data";
import { useLocationsMetadata } from "@atlas-int/data";
interface Props {
  pathname: string;
}

export const countryProfilesRedirectFlag = "redirectFromCP";

export function getRouteID({ pathname }: Props) {
  const matchedRouteWithID = [...routesAsSet].filter(
    (route: RouteMetadata) => route.path === pathname,
  );
  if (matchedRouteWithID.length == 1) {
    return matchedRouteWithID[0].id as RouteID;
  } else {
    throw new Error("Invalid route");
  }
}

export function getRoutePathFromRouteID({ routeId }: { routeId: RouteID }) {
  let matchedPath: string | undefined;
  let matchedRoute = [...routesAsSet].find(
    (route: RouteMetadata) => route.id === routeId,
  );
  if (matchedRoute) {
    matchedPath = matchedRoute.path;
  } else {
    matchedPath = undefined;
  }

  return matchedPath;
}

export function detectCountryProfilesRedirectFlag(
  searchParams: URLSearchParams,
) {
  return searchParams.get(countryProfilesRedirectFlag) === "true";
}

export function retrieveOldCountryIdFromCountryProfileRedirect(
  searchParams: URLSearchParams,
) {
  return searchParams.get("exporter") ?? undefined;
}

export const useOldCountryIds = () => {
  const [query, setQuery] = useExploreParams();
  const {
    view,
    exporter,
    importer,
    product,
    year,
    startYear,
    endYear,
    productClass,
    productLevel,
    tradeFlow,
  } = query;
  let queryParamsArray = [
    view,
    exporter,
    importer,
    product,
    year,
    startYear,
    endYear,
    productClass,
    productLevel,
    tradeFlow,
  ];

  const locationsState = useLocationsMetadata();

  useEffect(() => {
    const params = new URLSearchParams(Object.entries(query).map(([k, v]) => [k, String(v)]));
    let countryProfileRedirectFlagDetected =
      detectCountryProfilesRedirectFlag(params);

    if (countryProfileRedirectFlagDetected) {
      // If the Country Profiles redirect flag is in the URL,
      // need to first map old country ID to new country ID,
      // and then replace state with the new country ID

      if (locationsState.status === "success") {
        let mappedCountryId: string | undefined;

        let oldCountryId = retrieveOldCountryIdFromCountryProfileRedirect(
          params,
        );

        if (oldCountryId !== undefined) {
          let numericOldCountryId =
            getNumericIdFromStringLocationId(oldCountryId);

          let { countries } = locationsState.data;
          let matchingLocationMetadatum = countries.find(
            (country) => country.legacyCountryId == numericOldCountryId,
          );
          if (matchingLocationMetadatum) {
            mappedCountryId = String(matchingLocationMetadatum.countryId);
          }
        }
        setQuery({ exporter: mappedCountryId });
        // navigate("/explore/treemap", { replace: true });
      }
    }
  }, [...queryParamsArray, locationsState]);

};
